import { isAppMode } from "@/platform/app-mode/client"
import { commitSession, suspendSession } from "@/platform/session/publisher"
import { emitSessionExpired } from "@/platform/session/session-events"
import { sessionKeys } from "@/platform/session/session-keys"
import { ANONYMOUS_VIEWER } from "@/platform/session/viewer"

import type { QueryClient } from "@tanstack/react-query"

const CHANNEL_NAME = "nelo:session"

export const announceSessionChange = (): void => {
  if (typeof BroadcastChannel === "undefined") return
  const channel = new BroadcastChannel(CHANNEL_NAME)
  channel.postMessage("changed")
  channel.close()
}

export const handleUnauthorized = (queryClient: QueryClient, viewer: string): void => {
  if (viewer === ANONYMOUS_VIEWER || isAppMode()) return
  commitSession(queryClient, { kind: "anonymous" })
  emitSessionExpired()
}

export const syncSessionAcrossTabs = (queryClient: QueryClient): (() => void) => {
  const channel = typeof BroadcastChannel === "undefined" ? null : new BroadcastChannel(CHANNEL_NAME)
  const changed = () => suspendSession(queryClient)
  const pageShown = (event: PageTransitionEvent) => {
    if (event.persisted) void queryClient.invalidateQueries({ queryKey: sessionKeys.probe })
  }
  channel?.addEventListener("message", changed)
  window.addEventListener("pageshow", pageShown)
  return () => {
    channel?.removeEventListener("message", changed)
    channel?.close()
    window.removeEventListener("pageshow", pageShown)
  }
}
